var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as Styled from './CountryFlag.styled';
/**
 * CountryFlag
 *
 * This component renders a flag image based on the provided country code.
 * It assumes that the flag assets are stored locally in the `/flags/` directory
 * within the public folder and are named using lowercase ISO 3166-1 codes
 * (e.g., `us.svg`, `gb.svg`).
 */
var CountryFlag = function (_a) {
    var countryCode = _a.countryCode, props = __rest(_a, ["countryCode"]);
    if (!countryCode)
        return null;
    var normalizedCode = countryCode.toLowerCase();
    var flagPath = "/flags/".concat(normalizedCode, ".svg");
    return React.createElement(Styled.Flag, __assign({ src: flagPath, alt: "".concat(countryCode, " flag") }, props));
};
export default CountryFlag;
